import React, { Fragment } from "react"

import PlSeparator from "./PlSeparator"
import { scale } from "utils"

const PlCombinedOrdersPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const {
    tableNumber,
    combinedOrderCodes
  } = printData

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth)
      : stylesOthers

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["header"]}>
          (سفارشات ترکیب شدند)
        </div>

        <div style={styles["text"]}>
          میز:
          <b style={styles["bold"]}>
            {tableNumber}
          </b>
        </div>
        {combinedOrderCodes.map(combinedOrderCode =>
          <div key={combinedOrderCode} style={styles["text"]}>
            سفارش:{" "}
            <b style={styles["bold"]}>
              {combinedOrderCode}
            </b>
          </div>
        )}
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment >
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  header: {
    fontWeight: "bold",
    textAlign: "center"
  },

  text: {
    textAlign: "center",
  },
  bold: {
  }
})

const stylesOthers = {
  container: {
    marginRight: "8px",
    fontSize: "11px"
  },
  header: {
    fontWeight: "bold",
    textAlign: "center"
  },
  text: {
    textAlign: "center"
  },
  bold: {
    fontWeight: "bold"
  }
}

export default PlCombinedOrdersPrintTemplate